export const SMS_CODE_TIMEOUT = 60 * 1000;